import { getIntlLocale } from '@i18n';

// "12 de set. de 2026" — day-level only, no time. Post timestamps arrive as
// "Y-m-d H:i:s"; the space→T swap makes them parse as local time.
export function publishedLabel(iso) {
    if (!iso) return '';
    const date = new Date(String(iso).replace(' ', 'T'));
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString(getIntlLocale(), { day: 'numeric', month: 'short', year: 'numeric' });
}
